import Component from 'gia/Component';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// import styles bundle
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export default class CarouselTest extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
    this.options = {
      showNav: false,
      keepAutoSlidesLarge: false,
      keepAutoSlidesAll: false
    }
  }

  mount() {
    let options = {};
    options = {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 20,
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      adaptiveHeight: false,
      breakpoints: {}
    }


    const
      swiper = new Swiper(this.element, options);
    //
    // var flkty = new Flickity(this.element, {
    //   // options
    //   cellAlign: 'left',
    //   contain: true,
    //   setGallerySize: true,
    //   pageDots: this.options.showNav,
    //   imagesLoaded: true,
    //   freeScroll: false,
    //   adaptiveHeight: true,
    //   resize:true,
    //   groupCells: true,
    //   prevNextButtons: true,
    //   arrowShape: {
    //     x0: 10,
    //     x1: 60, y1: 50,
    //     x2: 65, y2: 45,
    //     x3: 20
    //   },
    //   on: {
    //     ready: function() {
    //       window.dispatchEvent(new Event('resize'));
    //     }
    //   }
    // });


  }


}